<template>
  <div class="medical-report-detail">
    <div :style="bluebg" class="medical-report-detail-bg">
      <div style="width:100%">体检报告详情</div>
      <div class="medical-report-detail-content">
        <div class="medical-report-detail-content-tab">
          <div
            v-if="reportInfo.reportType === '1'"
            class="medical-report-detail-content-tab-select"
          >
            报告详情
          </div>
          <div
            v-if="reportInfo.reportType === '2'"
            class="medical-report-detail-content-tab-select"
          >
            {{ reportInfo.checkItemName }}
          </div>
        </div>
        <div
          v-if="reportInfo.reportType === '1'"
          class="medical-report-detail-content-list"
        >
          <div
            v-for="(item, index) in list"
            :key="index"
            class="medical-report-detail-content-list-cell"
          >
            <div class="medical-report-detail-content-list-cell-name">
              {{ item.checkItemName1 }}
            </div>
            <div class="medical-report-detail-content-list-cell-results">
              <div>参考值：{{ item.referencerange }}</div>
              <div style="text-align: right;">
                结果：{{ item.examineresult }}
              </div>
              <div
                v-if="item.normalValue === '0'"
                class="medical-report-detail-content-list-cell-results-pic"
              >
                <img :src="require('@assets/medical_report_down.png')" alt="" />
              </div>
              <div
                v-if="item.normalValue === '2'"
                class="medical-report-detail-content-list-cell-results-pic"
              >
                <img :src="require('@assets/medical_report_down.png')" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="reportInfo.reportType === '2'"
          class="medical-report-detail-content-list"
        >
          <div class="medical-report-detail-content-list-cell2">
            <div style="display:flex;">
              <div>小结：</div>
              <div></div>
            </div>
            <div style="display:flex;margin-top:1rem;">
              <div>建议：</div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bluebg: {
        backgroundImage: `url(${require("@assets/vaccine_form_bluebg.png")}`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% auto"
      },
      list: [],
      startDate: "",
      endDate: "",
      showStart: false,
      showEnd: false,
      openId: "",
      tabindex: "0",
      reportInfo: {}
    };
  },
  created() {
    this.reportInfo = this.$route.query;
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$http
        .post(this.$api.MES_REPORT_DETAIL, {
          reportNo: this.reportInfo.reportNo,
          reportDetailNo: this.reportInfo.reportDetailNo,
          reportType: this.reportInfo.reportType
        })
        .then(res => {
          this.list = res;
        })
        .catch(() => {
          this.list = [];
        });
    },
    cancelClick(item) {
      this.$http
        .post(this.$api.VAC_CANCEL, {
          appointId: item.appointId,
          openId: this.openId,
          idCard: item.idCard
        })
        .then(res => {
          this.$dialog
            .alert({
              title: "",
              message: "取消成功"
            })
            .then(() => {
              this.getList();
            });
        })
        .catch(error => {
          alert(error.message);
        });
    }
  }
};
</script>
<style lang="less">
.medical-report-detail {
  background-color: #f7f8fa;
  &-bg {
    width: 100%;
    height: 17.5rem;
    padding-top: 1.66rem;
    color: white;
    font-weight: 500;
    font-size: 1.31rem;
    text-align: center;
  }
  &-content {
    margin: 1rem 5% 0.94rem 5%;
    &-tab {
      display: flex;
      overflow: hidden;
      font-weight: 500;
      font-size: 1rem;
      line-height: 3.14rem;
      text-align: center;
      border-radius: 0.63rem 0.63rem 0 0;
      &-select {
        width: 100%;
        color: #4396f7;
        background-color: #ecf9ff;
      }
    }
    &-detail {
      padding: 15px 1.13rem;
      background-color: white;
      border: 1px solid #e8e8e8;
      &-title {
        margin: 0 3rem;
        color: #4396f7;
        font-weight: 600;
        font-size: 0.84rem;
        line-height: 2rem;
        text-align: center;
        background-color: #ecf9ff;
        border-radius: 0.63rem;
      }
      &-content {
        padding: 1.47rem 0;
        color: #666;
        font-size: 0.74rem;
      }
    }
    &-list {
      background-color: white;
      border: 1px 1px 0 1px solid #e8e8e8;
      &-cell2 {
        padding: 1.25rem 0 1.25rem 1.25rem;
        color: #666;
        font-size: 0.65;
        text-align: left;
        border-bottom: 1px dotted #e8e8e8;
      }
      &-cell {
        height: 5.38rem;
        padding: 1.25rem 0.8rem 0 1.25rem;
        text-align: left;
        border-bottom: 1px dotted #e8e8e8;
        &-results {
          display: flex;
          justify-content: space-between;
          margin-top: 1.34rem;
          color: #999;
          font-weight: 400;
          font-size: 0.94rem;
          &-pic {
            width: 0.63rem;
            margin-top: -1rem;
            img {
              width: 100%;
            }
          }
        }
        &-name {
          color: #666;
          font-weight: 600;
          font-size: 1.13rem;
        }
      }
    }
  }
  &-info {
    margin: 1.78rem 5% 0 5%;
    padding: 0 1.25rem;
    color: #666;
    font-size: 0.94rem;
    line-height: 2.81rem;
    background-color: white;
    border-radius: 0.63rem;
    &-detail {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #f9f9f9;
      span {
        color: #333;
      }
    }
    &-number {
      display: flex;
      justify-content: space-between;
    }
  }
  .van-grid-item__content {
    padding: 0;
  }
}
</style>
